import React from 'react';
import { HashRouter, Route, Router } from 'react-router-dom';
import CacheRoute, { CacheSwitch } from 'react-router-cache-route';
import QuitApplication from './views/quitApplication/quitApplication';
import NewHome from './views/newHome/newCurHome.js';
import ParentGuidelines from './views/parentGuidelines/parentGuidelines';
import loadable from './util/loadable';
import ErrorToHomePage from './components/errorPage/errorPage';
const AllDesc = loadable(() => import('./views/desc/desc')); // 详情简介
// const FilterPage = loadable(() => import('./views/filterPage/filterPage')); // 筛选海信、三星版本
const FilterPage = loadable(() => import('./views/newFilterPage/newFilterPage'));
const FilterPageLG = loadable(() => import('./views/filterPageLG/filterPageLG')); // 筛选LG版本
const Search = loadable(() => import('./views/search/search')); // 查询
// const WatchHistory = loadable(() => import('./views/watchHistory/watchHistory')); // 观看历史
const WatchHistory = loadable(() => import('./views/history/history.js')); // 观看历史
const searchResult = loadable(() => import('./views/searchResult/searchResult')); // 查询结果
const SetUp = loadable(() => import('./views/setUp/setUp')); // 设置
const SoftwareInfo = loadable(() => import('./views/softwareInfo/softwareInfo')); // 关于我们
const HelpFeedback = loadable(() => import('./views/helpFeedback/helpFeedback')); // 帮助反馈
const Login = loadable(() => import('./views/login/login')); // 登录
const PhoneLogin = loadable(() => import('./views/phoneLogin/phoneLogin')); // 手机登录
const GuidePages = loadable(() => import('./views/guidePages/guidePages')); // 登录引导页
const Register = loadable(() => import('./views/register/register')); // 注册
const SelectArea = loadable(() => import('./views/selectArea/selectArea')); // 选择登录地区
const PhonePassword = loadable(() => import('./views/phonePassword/phonePassword')); // 输入登录密码
const EmailLogin = loadable(() => import('./views/emailLogin/emailLogin')); // 邮箱登录
const OrderVip = loadable(() => import('./views/orderVip/orderVip')); // 订购续费
const OpenVipRes = loadable(() => import('./views/openVipRes/openVipRes')); // 开通会员结果，主要针对astro侧开通后返回回来页面
const SignOut = loadable(() => import('./views/signOut/signOut')); // 退出登录
// const QuitApplication = loadable(() => import('./views/quitApplication/quitApplication')); // 退出应用
const LimitScenes = loadable(() => import('./views/limitScenes/limitScenes')); // 超前点播
const NoBuyScenes = loadable(() => import('./views/noBuyScenes/noBuyScenes')); // 未购买场景报错
const TermsService = loadable(() => import('./views/termsService/termsService')); // 服务条款
const PrivacyPolicy = loadable(() => import('./views/privacyPolicy/privacyPolicy')); // 隐私协议
const LiveStreamingFull = loadable(() => import('./views/liveStreamingFull/liveStreamingFull')); // 直播全屏页
const Loading = loadable(() => import('./views/loading/loading')); // loading页
const BackLoading = loadable(() => import('./views/backLoading/backLoading')); // 返回loading页
const Activity = loadable(() => import('./views/activity/activity')); // 跳活动拦截
const Particular = loadable(() => import('./views/newParticular/newParticular')); // 最新详情页
const TermsPolicy = loadable(() => import('./views/termsPolicy/termsPolicy')); // 服务条款和隐私协议
const EasterEgg = loadable(() => import('./views/easterEgg/easterEgg')); // 彩蛋页
const BasicRoute = () => (
  <HashRouter history={Router}>
    <CacheSwitch>
      {<CacheRoute exact path="/" component={NewHome}></CacheRoute>}
      <Route exact path="/allDesc/:cid/:type?" component={AllDesc} />
      <Route exact path="/filterPage/:first_category/:sort?" component={FilterPage} />
      <Route exact path="/filterPageLG/:first_category/:sort?" component={FilterPageLG} />
      <Route exact path="/search/:sourcePage?/:id?/:page?/:filterId?" component={Search} />
      <Route exact path="/watchHistory/" component={WatchHistory} />
      <Route exact path="/searchResult/:params" component={searchResult} />
      <Route exact path="/setUp/" component={SetUp} />
      <Route exact path="/softwareInfo/" component={SoftwareInfo} />
      <Route exact path="/helpFeedback/" component={HelpFeedback} />
      <Route exact path="/login/:type?" component={Login} />
      <Route exact path="/guidePages/" component={GuidePages} />
      <Route exact path="/register/:type?" component={Register} />
      <Route exact path="/phoneLogin/:areaId?" component={PhoneLogin} />
      <Route exact path="/selectArea/:areaId" component={SelectArea} />
      <Route exact path="/phonePassword/:phone/:type/:areaCode?" component={PhonePassword} />
      <Route exact path="/emailLogin/" component={EmailLogin} />
      <Route exact path="/orderVip/:source1?/:cid?/:vid?" component={OrderVip} />
      <Route exact path="/openVipRes" component={OpenVipRes}></Route>
      <Route exact path="/signOut/" component={SignOut} />
      <Route exact path="/quitApplication/" component={QuitApplication} />
      <Route exact path="/limitScenes/:cid?/:vid?" component={LimitScenes} />
      <Route exact path="/noBuyScenes/" component={NoBuyScenes} />
      <Route exact path="/termsService/" component={TermsService} />
      <Route exact path="/privacyPolicy/" component={PrivacyPolicy} />
      <Route exact path="/LiveStreamingFull/:pid/:streamId?" component={LiveStreamingFull} />
      <Route exact path="/Loading/:cid/:sourcePage?/:filterId?/:type?" component={Loading} />
      <Route exact path="/BackLoading/:cid/:sourcePage?" component={BackLoading} />
      <Route exact path="/Activity/" component={Activity} />
      <Route exact path="/Particular/:cid/:sourcePage?/:filterId?/" component={Particular} />
      <Route exact path="/parentGuidelines/" component={ParentGuidelines} />
      <Route exact path="/termsPolicy/" component={TermsPolicy} />
      <Route exact path="/easterEgg/" component={EasterEgg} />
      <Route exact path="/pageErr/" component={ErrorToHomePage} />
      <Route path="*" component={ErrorToHomePage} />
    </CacheSwitch>
  </HashRouter>
);

export default BasicRoute;
